import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { api } from '../api';
import { Card, Page, State } from '../components';

export function OverviewPage() {
  const agents = useQuery({
    queryKey: ['agents'],
    queryFn: () => api<{ data: unknown[] }>('/api/v1/agents'),
  });
  const conversations = useQuery({
    queryKey: ['conversations'],
    queryFn: () => api<{ data: unknown[] }>('/api/v1/conversations'),
  });
  const handoffs = useQuery({
    queryKey: ['handoffs'],
    queryFn: () => api<{ data: Array<{ status: string }> }>('/api/v1/handoffs'),
  });
  const loading = agents.isLoading || conversations.isLoading || handoffs.isLoading;
  const error = agents.error ?? conversations.error ?? handoffs.error;
  return (
    <Page title="Overview" description="Live workspace totals—nothing here is synthetic.">
      <State loading={loading} error={error}>
        <div className="metric-grid">
          <Card>
            <small>Configured agents</small>
            <strong>{agents.data?.data.length ?? 0}</strong>
            <Link to="/agents">Manage agents</Link>
          </Card>
          <Card>
            <small>Conversations</small>
            <strong>{conversations.data?.data.length ?? 0}</strong>
            <Link to="/conversations">Review conversations</Link>
          </Card>
          <Card>
            <small>Open handoffs</small>
            <strong>
              {handoffs.data?.data.filter((item) => ['REQUESTED', 'ACCEPTED'].includes(item.status))
                .length ?? 0}
            </strong>
            <Link to="/handoffs">Open handoff queue</Link>
          </Card>
        </div>
        <Card className="getting-started">
          <h2>Demo readiness</h2>
          <ol>
            <li>Create an agent with clear support instructions.</li>
            <li>Add the exact website origin where the widget runs.</li>
            <li>Upload fictional or approved knowledge, then wait for Ready.</li>
            <li>Embed the agent’s public ID and test a supported and unsupported question.</li>
          </ol>
        </Card>
      </State>
    </Page>
  );
}
